import _ from 'lodash';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import defaultStyles from '../../styles/formSetStyles.module.css';

export const validEmailRegex =
  // eslint-disable-next-line no-control-regex
  /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;

interface Props {
  label: string;
  className?: string;
  id?: string;
  placeholder?: string;
  saveFieldValue: (value: string) => void;
  updateFieldValue: (value: string) => void;
  value?: string;
}

export function Email(props: Props) {
  const {
    label,
    className,
    id,
    placeholder,
    saveFieldValue,
    updateFieldValue,
    value,
  } = props;

  const [validEmail, setValidEmail] = useState(true);
  const { t } = useTranslation();

  const checkEmail = (email: string) => {
    if (!isValidEmail(email)) {
      setValidEmail(false);
      return;
    }

    setValidEmail(true);
    saveFieldValue(email);
  };

  const onFocus = (event: React.FocusEvent<HTMLInputElement>) => {
    const { value } = event.target;

    if (value) checkEmail(value);
  };

  return (
    <>
      <div className={defaultStyles.InputWrapper}>
        <input
          id={id}
          className={[
            defaultStyles.Input,
            !validEmail && defaultStyles.Invalid,
            className,
          ]
            .filter((x) => !!x)
            .join(' ')}
          onBlur={(event: React.FocusEvent<HTMLInputElement>) => {
            checkEmail(event.target.value);
          }}
          onChange={(event: React.FormEvent<HTMLInputElement>) => {
            const { value } = event.currentTarget;

            updateFieldValue(value);
            checkEmail(value);
          }}
          onFocus={onFocus}
          placeholder={placeholder}
          type="email"
          value={value}
        />
      </div>
      {!validEmail && (
        <div className={defaultStyles.InvalidHint}>
          {_.capitalize(
            t('invalidInputError', {
              type: t('email'),
              label,
            }),
          )}
        </div>
      )}
    </>
  );
}

export const isValidEmail = (email: string): boolean => {
  return validEmailRegex.test(email.toLowerCase());
};
